/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import clsx from 'clsx';

import { MEDIA_TYPE } from '@api/media/constants';
import { useModalControls } from '@hooks';
import { ImagePreview, DocumentPreview } from '@molecules';
import * as mediaUtils from '@utils/media';

import UpsertMediaModal from '../UpsertMediaModal';

import s from './styles.module.less';

const MediaTile = ({ media, selectable, isSelected, checkbox, onSelect }) => {
  
  const modal = useModalControls();

  const extension = media?.fileName?.split('.')[1] || '';

  const handleClick = React.useCallback(() => {
    if (onSelect) {
      onSelect(media);
    } else {
      modal.show();
    }
  }, [media, modal, onSelect]);

  return (
    <>
      <li className={clsx(s.item, isSelected && s.selected)}>
        <button type="button" className={s.wrapper} onClick={handleClick}>
          {media.type === MEDIA_TYPE.IMAGE && <ImagePreview src={mediaUtils.getSrc({ media, thumbnail: true })} />}
          {media.type === MEDIA_TYPE.DOCUMENT && <DocumentPreview title={media.title} extension={extension}/>}
          {selectable && <div className={s.options}>{checkbox(media)}</div>}
        </button>
      </li>
      <UpsertMediaModal {...modal} media={media} />
    </>
  );
};

export default MediaTile;
